export const CharAlert = () => {
  return (
    <div className="form__alert">
      <span className="form__alert-text">
        Your tweet can't exceed 140 characters!
      </span>
    </div>
  )
}

export const ErrorText = () => {
  return (
    <div className="form__error">
      <span className="form__error-text">
        Server Error - Your tweet wasn't published!
      </span>
    </div>
  )
}